import { EXTRUSION, RECTANGLE_BAR } from '../config/constants';

export const getEffectiveShapeName = (
	displayName: string | null | undefined
): string | null | undefined => {
	if (!displayName) return displayName;
	return displayName === EXTRUSION ? RECTANGLE_BAR : displayName;
};
